import React, { createContext, useContext, useState } from 'react';

interface InsuredDetailContextValue {
  selectedInsuredId: string | null;
  setSelectedInsuredId: (id: string | null) => void;
}

const InsuredDetailContext = createContext<InsuredDetailContextValue>({
  selectedInsuredId: null,
  setSelectedInsuredId: () => {},
});

export const InsuredDetailProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [selectedInsuredId, setSelectedInsuredId] = useState<string | null>(null);
  return (
    <InsuredDetailContext.Provider value={{ selectedInsuredId, setSelectedInsuredId }}>
      {children}
    </InsuredDetailContext.Provider>
  );
};

export const useInsuredDetail = () => useContext(InsuredDetailContext);
